import React from "react";
import Close from "../../../../../assets/media/svgs/Close";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  width?: string;
  height?: string;
  maxHeight?: string;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  width = "480px",
  height = "auto",
  maxHeight,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 rounded-2xl flex items-center justify-center p-4">
      <div
        className="fixed inset-0"
        style={{ backgroundColor: "rgba(18, 18, 18, 0.8)" }}
        onClick={onClose}
      />

      <div
        className="relative bg-white rounded-2xl overflow-hidden shadow-xl w-full flex flex-col"
        style={{ width, height, maxHeight: maxHeight || "90vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center px-6 py-4">
          <button
            onClick={onClose}
            className="absolute focus:outline-none  right-4 top-0 mt-6 text-3xl font-medium text-dark hover:text-gray-600 cursor-pointer"
            aria-label="Close modal"
          >
            <Close className="w-6 h-6" />
          </button>

          <h2 className="flex-1 text-2xl font-medium text-primary text-center">
            {title}
          </h2>
        </div>

        <div className="relative overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;
